import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=816ab878&scoped=true&"
import script from "./HeaderBar.vue?vue&type=script&lang=ts&"
export * from "./HeaderBar.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=816ab878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816ab878",
  null
  
)

export default component.exports